module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-connect-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sk-main-wide"
  }, [_c('div', {
    staticClass: "sk-two-col-card sk-invite-card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('div', {
    staticClass: "sk-spinner",
    staticStyle: {
      "margin": "0 auto 16px"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loading…")])]) : (_vm.status === 'used') ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('div', {
    staticClass: "sk-amz-connected"
  }, [_c('span', {
    staticClass: "sk-micro-tick"
  }, [_vm._v("✓")]), _vm._v(" Done. " + _vm._s(_vm.inviterName) + " can see your listings in SentryKit now.")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v("You can close this page. No SentryKit account was created for you.")])]) : (_vm.status === 'expired' || _vm.status === 'missing') ? _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('h1', [_vm._v("This link can't be used")]), _vm._v(" "), _c('p', {
    staticClass: "sk-form-sub"
  }, [_vm._v(_vm._s(_vm.status === 'expired' ? 'This link has expired. Ask them to copy a new one from SentryKit.' : 'This link is not valid.'))])]) : _c('div', {
    staticClass: "sk-form-panel"
  }, [_c('p', {
    staticClass: "sk-invite-lead"
  }, [_vm._v(_vm._s(_vm.inviterName) + " asked you to connect " + _vm._s(_vm.accountLabel) + "'s Amazon store to SentryKit.")]), _vm._v(" "), _c('connect-region-form', {
    attrs: {
      "working": _vm.working,
      "error": _vm.error
    },
    on: {
      "connect": _vm.startConnect
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-topbar"
  }, [_c('a', {
    staticClass: "sk-logo",
    attrs: {
      "href": "https://sentrykit.com"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "48px",
      "width": "auto",
      "display": "block"
    },
    attrs: {
      "src": "https://sentrykit.com/wp-content/uploads/2026/04/Sk-2.0-logo-white.png",
      "alt": "SentryKit"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33c95238!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ConnectInvitePage.vue
// module id = 745
// module chunks = 2